import React, {Component, useDebugValue, useEffect, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col } from 'react-bootstrap';
import { Container, Row, FormControl, FormLabel, FormCheck } from 'react-bootstrap';
import AreaN2DataService from './services/arean2.service.js';
import OrganigramaAreaDataService from './services/organigramaarea.service.js';
import UserDataService from './services/user.serviceaux.js';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import { IoAddCircle } from "react-icons/io5";

function AgregarAreaN2(props) { 

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(props.mode);


  const [areasn2, setareasn2] = useState([]);  
  const [arean2id, setarean2id] = useState(null);  
  const [descripcionarea, setdescripcionarea] = useState("");  
  const [juezid, setjuezid] = useState(null);  
  const [users, setUsers] = useState([]);
  
  const { user } = useSelector(state => state.auth);

  useEffect(() => {
    UserDataService.getAll()
    // asegurarse de que se imprima la lista de usuarios aquí
    .then((resp) => {
      console.log(resp.data);
      setUsers(resp.data);
    })
    .catch((err) => {
      console.error("No se pueden cargar los registros de usuario:" + err);
    })

  },[])

  const onchangearean2 = (e) => {  
    console.log(e.target.value);
    const arean2id = parseInt(e.target.value);
    console.log(arean2id);
    //setarean2id(areasn2.find(obj => obj.id === arean2id) || null);   
    setarean2id(arean2id);
    //setdescripcionarea((areasn2.find(obj => obj.id === arean2id) || {})).nombrearea;
  };

  const onchangejuez = (e) => {  
    console.log(e.target.value);
    const juezid = parseInt(e.target.value);
    console.log(juezid);
    setjuezid(juezid);
  };   
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    AreaN2DataService.getAreaN2ByDescr('','id','ASC',props.arean1?props.arean1.id:null)
    .then(response => {
        console.log(response.data);
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);   
        setareasn2(response.data); 
        //setarean2id(response.data[0].id);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    });     
  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    saveAreaOrganigrama();
  } 

  let saveAreaOrganigrama = (e)  =>{ 
    console.log(e.arean2id);
    console.log(areasn2);
    console.log(props);
    let desc = (areasn2.find(obj => obj.id === parseInt(e.arean2id)) || {}).nombrearea;
    var data = {
      parentid: props.parentid,
      childid: e.arean2id,
      childcategory: 'arean2',
      childdescription: desc,
      userId: e.juezid
    }
    
    console.log(data);

    OrganigramaAreaDataService.create(data)
      .then(response => {
      console.log(response.data);
      setSubmitted(true);
      handleClose();
    })
    .catch(e => {
      console.log(e);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);      
      setSuccmessage('');
      setShowsuccess(false);            
    })  

      
  }


    return (
      <>
        <Button variant="secondary" onClick={handleShow}><IoAddCircle size={15}/></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Agregar área N2'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(saveAreaOrganigrama)}>
              <Row className='mt-2'>
                <Col className='col-md-3' md={6}>
                  <Form.Label>Nombre área N1</Form.Label>
                  <FormControl style={{maxWidth:"300px"}} type="text" name="nombrearean1" id="nombrearean1" disabled defaultValue={props.arean1?props.arean1.nombrearea:null}></FormControl>
                </Col>
              </Row>

              <Row className='mt-2'>
                <Col className='col-md-3' md={6}>
                    <Controller
                        name="arean2id"
                        control={control}
                        onChange={onchangearean2}
                        defaultValue={arean2id}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Select
                            {...field}
                              //onChange={onchangearean2}
                              className="mt-2"
                              type="select"
                              //placeholder="Nombre competencia"
                              isInvalid={errors.arean2id}
                            >
                              <option key={0} value={0}>{"Seleccionar área N2"}</option>
                              {
                                areasn2.map((row,index) => {
                                  return (
                                    <option key={index} value={row.id}>{row.nombrearea}</option>
                                  )
                                })
                              }
                            </Form.Select>
                        )}
                    />
                    {errors.arean2id && (
                        <Form.Control.Feedback type="invalid">
                            Se requiere área N2.
                        </Form.Control.Feedback>
                    )}
                </Col>                 
                <Col className='col' md={6}>
                    <Controller
                      name="juezid"
                      control={control}
                      onChange={onchangejuez}
                      //defaultValue={userid}
                      defaultValue={juezid}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Form.Select
                          {...field}
                            className="mt-2"
                            type="text"
                            placeholder="Primer nombre"
                            isInvalid={errors.juezid}
                            //onChange={onchangejuez}
                            //value={username}
                        >
                          <option key={0} value={0}>{"Seleccionar juez"}</option>
                          {
                            users.map((row,index) => {
                              return (
                                <option key={index} value={row.id}>{row.primerapellido + ", " + row.primernombre}</option>
                              )
                            })
                          }                            
                        </Form.Select>
                      )}
                    />
                    {errors.juezid && (
                      <Form.Control.Feedback type="invalid">
                        Se requiere el juez
                      </Form.Control.Feedback>
                    )}
                </Col>                 
              </Row>
              <hr />
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block" >
                  Agregar y cerrar
                </button>            
              </div> 

            </Form>
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Hecho</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default AgregarAreaN2;